export enum LendingUnits {
  animationShow = '-30%',
  animationShowFooter = '-10%'
}